import React, { FunctionComponent } from "react";
import CenteredLoader from "../common/loading/CenteredLoader";
import Errors from "components/Errors";
import { useIntl } from "react-intl";
import { LoginStatus, useLoginStatus } from "../user-context";

const SessionGate: FunctionComponent = ({ children }) => {
  const status = useLoginStatus();
  const intl = useIntl();
  switch (status) {
    case LoginStatus.PENDING:
      return <CenteredLoader />;
    case LoginStatus.LOGGED_OUT:
      return (
        <Errors
          main={intl.formatMessage({ id: "errors.expired" })}
          sub={intl.formatMessage({ id: "errors.reload" })}
        />
      );
    case LoginStatus.LOGGED_IN:
    default:
      return <>{children}</>;
  }
};

export default SessionGate;
